import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationExtras, Resolve, Router, RouterStateSnapshot } from '@angular/router';

import { TicketsService } from '@shared/services/ticketing.service';

@Injectable({
  providedIn: 'root'
})
export class SysIdResolver implements Resolve<any> {
  constructor(private _router: Router, private ticketingService: TicketsService, private router: Router) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<unknown> {
    const accessingFrom = route.data['accessingFrom'];

    return new Promise((resolve, reject) => {
      this.ticketingService.getUserSysId(accessingFrom).then(
        (sysId: string) => {
          resolve(sysId);
        },
        err => {
          console.log(err, 'sysid-resolver');
          let navigationExtras: NavigationExtras;
          if (err && err.status && (err.status === 0 || err.status === 404)) {
            navigationExtras = {
              state: {
                accessError: true
              }
            };
          } else if (err && err.status && (err.status === 401 || err.status === 403)) {
            navigationExtras = {
              state: {
                unauthorizedError: true
              }
            };
          } else {
            navigationExtras = {
              state: {
                sysIdError: true
              }
            };
          }
          this.router.navigate(['error'], navigationExtras).then(r => {});

          reject();
        }
      );
    });

    // const accessingFrom = route.data['accessingFrom'];
    // return this.ticketingService.getUserSysId(accessingFrom);
  }
}
